import React from "react";
import "./App.css";

function App() {
  return (
    <div className="app-root">
      <div className="app-card">
        <h1 className="app-title">Tanya Norman</h1>
        <h2 className="app-subtitle">Japanese Paper Collage Art</h2>
        <p className="app-message">
          Our website is under construction.
          <br />
          Please check back soon to explore Tanya's unique collage artworks!
        </p>
        <div className="app-thankyou">
          Thank you for your patience and support.
        </div>
      </div>
      <div className="app-footer">
        &copy; {new Date().getFullYear()} Tanya Norman Art
      </div>
    </div>
  );
}

export default App;
